export default __webpack_public_path__ + "static/media/002.d09fcdfc.md";